import { FormEntity } from "components/FormEntity";
import React, { Fragment, useState } from "react";

import { ToastContainer } from "react-toastify";
import Loading from "../../../components/Loading";
import Dashboard from "../../../components/Template/Dashboard";
import ArrowLeft from "../../../icons/arrow-circle-left-green.svg";

type Props = {};

const EntityStore: React.FC<Props> = (): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingPlans, setLoadingPlans] = useState<boolean>(false);

  const [id, setId] = useState("");
  const [name, setName] = useState("");

  return (
    <Dashboard
      icon={ArrowLeft}
      title={"Create Entity’s Account"}
      breadcrumb={[
        {
          name: "Entity Management",
          active: false,
          path: "/entity-management",
        },
        { name: "Create Account", active: true },
      ]}
      children={
        <Fragment>
          <Loading loading={loading || loadingPlans} />
          <FormEntity
            setLoading={setLoading}
            setLoadingPlans={setLoadingPlans}
            id={id}
            name={name}
            setName={setName}
            setId={setId}
          />
          <ToastContainer />
        </Fragment>
      }
    />
  );
};

export default EntityStore;
